import * as React from 'react';

import { ColorPickerDropdown } from './ColorPickerDropdown';
import { RecentColorsLsManager } from './RecentColorsLsManager';

interface ColorPickerWithLsDropdownProps extends React.Props<ColorPickerWithLsDropdown> {
    Icon: React.ReactElement<__MaterialUI.SvgIconProps>;
    text: string;
    hexColor: string;
    initialMode?: number;
    onChange: (hexColor: string, isDefaultColor: boolean) => void;
}

export class ColorPickerWithLsDropdown extends React.Component<ColorPickerWithLsDropdownProps, {}> {

    render() {
        return (
            <ColorPickerDropdown
                Icon={this.props.Icon}
                text={this.props.text}
                hexColor={this.props.hexColor}
                initialMode={this.props.initialMode}
                recentColors={RecentColorsLsManager.getRecentColors()}
                onChange={this.onColorChange}
            />
        );
    }

    private onColorChange = (hexColor: string, isDefaultColor: boolean) => {
        if (!isDefaultColor) {
            RecentColorsLsManager.saveColor(hexColor);
        }

        this.props.onChange(hexColor, isDefaultColor);
    };

}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/components/color-picker/ColorPickerWithLsDropdown.tsx
 **/